let canvas: CanvasRenderingContext2D;
let sobelCanvas: CanvasRenderingContext2D;

const MEASURE_TIME = false;
const CAP_FPS = false;

function log(message: string): void {
  const logElement = document.getElementById("log");
  if (!logElement) throw new Error("Log section not found");
  logElement.textContent += message;
}

async function loop(videoElement: HTMLVideoElement): Promise<void> {
  if (videoElement.paused || videoElement.ended) {
    return;
  }

  try {
    await computeCanvas(videoElement);
  } catch (err) {
    log(String(err));
    throw err;
  }

  if (CAP_FPS) {
    setTimeout(() => {
      loop(videoElement);
    }, 1000);
  } else {
    loop(videoElement);
  }
}

const numWorkers = 8;
const workers: Worker[] = [];
for (let i = 0; i < numWorkers; i += 1) {
  workers.push(new Worker("sobel_worker.js"));
}

async function computeCanvas(videoElement: HTMLVideoElement): Promise<void> {
  if (MEASURE_TIME) {
    console.time("all");
    console.time("getImageData");
  }


  canvas.drawImage(
    videoElement,
    0,
    0,
    videoElement.videoWidth,
    videoElement.videoHeight,
  );

  const frame = canvas.getImageData(
    0,
    0,
    videoElement.videoWidth,
    videoElement.videoHeight,
  );
  const frameData = frame.data;

  if (MEASURE_TIME) {
    console.timeEnd("getImageData");
    console.time("workLoop");
  }

  const jobs: Promise<void>[] = [];

  const chunkSize = Math.floor(frameData.length / numWorkers);
  for (let i = 0; i < numWorkers; i += 1) {
    const startIndex = i * chunkSize;
    const endIndex =
      i === numWorkers - 1 ? frameData.length : (i + 1) * chunkSize;

    const worker = workers[i];

    if (!worker) {
      throw new Error(`Worker at index ${i} is not initialized`);
    }

    jobs.push(
      new Promise((resolve, reject) => {
        worker.onmessage = (e: MessageEvent<Uint8Array>) => {
          const sobelValues = e.data;
          worker.onmessage = null;
          worker.onerror = null;
          frameData.set(sobelValues, startIndex);
          resolve();
        };
        worker.onerror = reject;
        worker.postMessage(
          {
            frameData,
            startIndex,
            endIndex,
            videoWidth: videoElement.videoWidth,
            videoHeight: videoElement.videoHeight,
          }
        );
      }),
    );
  }

  await Promise.all(jobs);

  if (MEASURE_TIME) {
    console.timeEnd("workLoop");
    console.time("putImageData");
  }

  if (sobelCanvas) {
    sobelCanvas.putImageData(frame, 0, 0);
  }

  if (MEASURE_TIME) {
    console.timeEnd("putImageData");
    console.timeEnd("all");
  }
}

(async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: {
        // smaller resolution
        width: { ideal: 640 },
      },
    });

    const videoElement = document.getElementById("videoElement");
    if (!videoElement || !(videoElement instanceof HTMLVideoElement)) {
      throw new Error("videoElement not found");
    }

    videoElement.addEventListener("play", () => loop(videoElement), false);
    videoElement.srcObject = stream;

    const videoTrack = stream.getVideoTracks()[0];
    if (!videoTrack) {
      throw new Error("No video track found");
    }

    const settings = videoTrack.getSettings();
    const videoHeight = settings.height;
    const videoWidth = settings.width;

    if (!videoHeight || !videoWidth) {
      throw new Error("No dimensions on video");
    }

    const canvasElement = document.getElementById("canvas");
    if (!canvasElement || !(canvasElement instanceof HTMLCanvasElement)) {
      throw new Error("canvasElement not found");
    }

    const sobelCanvasElement = document.getElementById("sobelCanvas");
    if (!sobelCanvasElement || !(sobelCanvasElement instanceof HTMLCanvasElement)) {
      throw new Error("sobelCanvasElement not found");
    }

    canvasElement.height = videoHeight;
    sobelCanvasElement.height = videoHeight;

    canvasElement.width = videoWidth;
    sobelCanvasElement.width = videoWidth;

    const canvasCheck = canvasElement.getContext("2d")
    if (!canvasCheck) {
      throw new Error("No canvas context");
    }

    const sobelCanvasCheck = sobelCanvasElement.getContext("2d")
    if (!sobelCanvasCheck) {
      throw new Error("No sobelCanvas context");
    }

    canvas = canvasCheck;
    sobelCanvas = sobelCanvasCheck;

    videoElement.srcObject = stream;
  } catch (err) {
    log(String(err));
    throw err;
  }
})()
